import { scrollToEl } from './smoothScroller.js'

export const careers = () => {

	tags()
}

const tags = () => {

	let tagButtons = document.querySelectorAll('.tag-button')
	let items = document.querySelectorAll('.items .item')
	let filterDiv = document.querySelector('.filter')

	if (!tagButtons.length) return

	tagButtons.forEach(button => {
		button.addEventListener('click', () => {
			const selectedTag = button.getAttribute('data-tag').toLowerCase()

			if (selectedTag === 'all') {
				items.forEach(item => item.style.display = '')
				filterDiv.classList.remove('disable-search')
			} else {
				items.forEach(item => {
					const tags = item.getAttribute('data-tags').toLowerCase().split(' ')
					if (tags.includes(selectedTag)) {
						item.style.display = ''
					} else {
						item.style.display = 'none'
					}
				})
				filterDiv.classList.add('disable-search')
			}
		})
	})
}

export default () => { }